import script from "./Statistics.vue?vue&type=script&lang=ts&setup=true"
export * from "./Statistics.vue?vue&type=script&lang=ts&setup=true"

import "./Statistics.vue?vue&type=style&index=0&id=5a827d18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a827d18"]])

export default __exports__